module.exports = __webpack_public_path__ + "img/nhanvien.b8c3a909.png";